import { Outlet } from 'react-router-dom';

const MigrationPage = () => {
  return <Outlet />;
};

export default MigrationPage;
